<div class="page-wrapper compact-wrapper" id="pageWrapper">
    <router-outlet></router-outlet>
</div>